import React from "react";
import { Card } from "semantic-ui-react";
import LessonSummary from "./LessonSummary";

const headerStyle = {
  flexGrow: 0,
};

export default function MyPerformanceLessonsCard(props) {
  const { lessons = {} } = props.report;
  const {
    lessonsCount = 0,
    workloadTotalTime = 0,
    workloadWatchedTime = 0,
  } = lessons;

  return (
    <Card fluid padded>
      <Card.Content style={headerStyle}>
        <Card.Header>Aulas</Card.Header>
      </Card.Content>
      <Card.Content>
        <LessonSummary
          lessonsCount={lessonsCount}
          workloadTotalTime={workloadTotalTime}
          workloadWatchedTime={workloadWatchedTime}
        />
      </Card.Content>
    </Card>
  );
}
